import apiPublico from './axiosPublico';

/**
 * Registro con pago (Wompi).
 *
 * Usa el cliente PÚBLICO: quien se registra todavía no tiene cuenta, y el
 * cliente normal lo mandaría a la pantalla de acceso ante cualquier 401 —a
 * media compra, que es el peor momento posible—.
 */
const onboardingService = {
  /** Catálogo de planes con sus precios. La portada los lee de aquí. */
  getPlans: async () => {
    const { data } = await apiPublico.get('/onboarding/plans');
    return data;
  },

  validarCupon: async (code, plan) => {
    const { data } = await apiPublico.post('/onboarding/validate-coupon', { code, plan });
    return data;
  },

  /** Crea la compra y devuelve la URL de pago de Wompi. */
  iniciar: async (payload) => {
    const { data } = await apiPublico.post('/onboarding/initiate', payload);
    return data;
  },

  /** Estado de la compra; se consulta en bucle al volver del pago. */
  estado: async (referencia) => {
    const { data } = await apiPublico.get(`/onboarding/status/${referencia}`);
    return data;
  },

  /**
   * Verifica el regreso desde la pasarela.
   *
   * Hay que reenviar TODOS los parámetros que puso Wompi en la URL: el
   * servidor recalcula el hash con ellos y, si cuadra, crea la residencial
   * sin esperar al webhook —que a veces llega tarde o no llega—.
   */
  verificarRegreso: async (params) => {
    const { data } = await apiPublico.get('/onboarding/verify-redirect', { params });
    return data;
  },
};

export default onboardingService;
